var _excluded = ["ariaLabel", "icon", "isQuiet", "labelText", "children", "onOpenChange", "tooltip"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ActionButton, DialogTrigger, Icon, Text } from "../spectrum/index.js";
import { Tooltip } from "../popper/index.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Dialog trigger based on an ActionButton.
 */
export function ActionButtonDialogTrigger(_ref) {
  var ariaLabel = _ref.ariaLabel,
    icon = _ref.icon,
    isQuiet = _ref.isQuiet,
    labelText = _ref.labelText,
    children = _ref.children,
    onOpenChange = _ref.onOpenChange,
    tooltip = _ref.tooltip,
    styleProps = _objectWithoutProperties(_ref, _excluded);
  var iconClassName = labelText == null && tooltip != null ? 'action-button-icon-with-tooltip' : undefined;
  return /*#__PURE__*/_jsxs(DialogTrigger, {
    type: "popover",
    onOpenChange: onOpenChange,
    children: [/*#__PURE__*/_jsxs(ActionButton
    // eslint-disable-next-line react/jsx-props-no-spreading
    , _objectSpread(_objectSpread({}, styleProps), {}, {
      "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : labelText,
      isQuiet: isQuiet,
      children: [/*#__PURE__*/_jsx(Icon, {
        UNSAFE_className: iconClassName,
        children: /*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: icon
        })
      }), labelText == null ? null : /*#__PURE__*/_jsx(Text, {
        children: labelText
      }), tooltip == null ? null : /*#__PURE__*/_jsx(Tooltip, {
        children: tooltip
      })]
    })), children]
  });
}
export default ActionButtonDialogTrigger;
//# sourceMappingURL=ActionButtonDialogTrigger.js.map